export default "__VITE_ASSET__DgYMKpGG__"